/**
 * @generated SignedSource<<ee813641d45ce26b9c72d85479c9e442>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type myInfoQuery$variables = Record<PropertyKey, never>;
export type myInfoQuery$data = {
  readonly bznavRefund: {
    readonly user: {
      readonly createdAt: any | null | undefined;
      readonly email: string | null | undefined;
      readonly lastLoginType: string | null | undefined;
      readonly name: string | null | undefined;
      readonly phone: string | null | undefined;
    };
  };
  readonly checkUserLeave: {
    readonly canLeave: boolean;
  } | null | undefined;
};
export type myInfoQuery = {
  response: myInfoQuery$data;
  variables: myInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BznavRefundOutput",
    "kind": "LinkedField",
    "name": "bznavRefund",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RefundUserType",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastLoginType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CheckUserLeaveOutput",
    "kind": "LinkedField",
    "name": "checkUserLeave",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canLeave",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "myInfoQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "myInfoQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b9d907e43171f399cb468140a2a8a520",
    "id": null,
    "metadata": {},
    "name": "myInfoQuery",
    "operationKind": "query",
    "text": "query myInfoQuery {\n  bznavRefund {\n    user {\n      email\n      phone\n      name\n      lastLoginType\n      createdAt\n    }\n  }\n  checkUserLeave {\n    canLeave\n  }\n}\n"
  }
};
})();

(node as any).hash = "0874ba07467090aa46b2f059eab94dbf";

export default node;
